export default __webpack_public_path__ + "static/media/empty-question.550a7e26.svg";